/**
 * @generated SignedSource<<6360861c963fc9e1becd6643e05fd865>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LockNote_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly hasAccessToNoteLocking: boolean;
    };
  };
  readonly " $fragmentType": "LockNote_viewer";
};
export type LockNote_viewer$key = {
  readonly " $data"?: LockNote_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"LockNote_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LockNote_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToNoteLocking",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "note_locking"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"note_locking\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9ed03d5e979cc9ca552bc6c84c49047e";

export default node;
